import { render, staticRenderFns } from "./RichTextHighlightBox.vue?vue&type=template&id=702b7950&scoped=true&"
import script from "./RichTextHighlightBox.vue?vue&type=script&lang=js&"
export * from "./RichTextHighlightBox.vue?vue&type=script&lang=js&"
import style0 from "./RichTextHighlightBox.vue?vue&type=style&index=0&id=702b7950&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "702b7950",
  null
  
)

export default component.exports